import React, { useState, useEffect, forwardRef } from 'react';
import './Input.css';

interface InputProps {
  onChange?: (value: string) => void;
  onSubmit?: (value: string) => void;
  initialValue?: string;
  isDisabled?: boolean;
  placeholder?: string;
  trim?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(({
  initialValue = '',
  isDisabled = false,
  placeholder = '',
  onChange,
  onSubmit,
  trim = false,
}, ref) => {
  
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    setValue(trim ? initialValue.trim() : initialValue);
  }, [initialValue]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    onChange && onChange(newValue);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSubmit && onSubmit(value);
      e.preventDefault();
      e.stopPropagation();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    e.stopPropagation();
  };
  
  return (
    <input
      ref={ref}
      className={`
      ${isDisabled ? 'isDisabled' : ''} 
      `}
      type='text'
      placeholder={initialValue === '' ? placeholder : undefined}
      value={value}
      onChange={handleChange}
      disabled={isDisabled}
      onKeyPress={handleKeyPress}
      onKeyDown={handleKeyDown}
    />
  );
});

export default Input;
